import React from 'react';
import { GraduationCap, Building2, BarChart3, Landmark, ArrowRight } from 'lucide-react';
import { useCases } from '../data/mock';

const iconMap = {
  GraduationCap,
  Building2,
  BarChart3,
  Landmark
};

const UseCasesSection = () => {
  return (
    <section id="usecases" className="py-24 bg-slate-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="inline-block px-4 py-1.5 rounded-full bg-emerald-100 text-emerald-700 text-sm font-semibold mb-4">
            Kullanım Alanları
          </span>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-slate-800 mb-6">
            Her Sektör İçin
            <span className="text-blue-600"> Çözümler</span>
          </h2>
          <p className="max-w-2xl mx-auto text-lg text-slate-600">
            Akademiden kurumsal dünyaya, kamu sektöründen iş zekasına kadar
            geniş bir yelpazede değer üretin.
          </p>
        </div>

        {/* Use Cases Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {useCases.map((useCase, index) => {
            const Icon = iconMap[useCase.icon];
            const gradients = [
              'from-blue-500 to-cyan-500',
              'from-emerald-500 to-teal-500',
              'from-amber-500 to-orange-500',
              'from-violet-500 to-purple-500'
            ];

            return (
              <div
                key={useCase.id}
                className="group bg-white rounded-2xl border border-slate-200 p-6 hover:shadow-xl hover:border-transparent transition-all duration-500"
              >
                {/* Icon */}
                <div className={`w-14 h-14 rounded-2xl bg-gradient-to-br ${gradients[index]} flex items-center justify-center mb-5 shadow-lg`}>
                  <Icon className="w-7 h-7 text-white" />
                </div>

                {/* Title & Description */}
                <h3 className="text-lg font-bold text-slate-800 mb-2 group-hover:text-blue-600 transition-colors">
                  {useCase.title}
                </h3>
                <p className="text-slate-600 text-sm mb-4 leading-relaxed">
                  {useCase.description}
                </p>

                {/* Highlights */}
                <div className="flex flex-wrap gap-1.5">
                  {useCase.highlights.map((highlight, idx) => (
                    <span
                      key={idx}
                      className="px-2 py-1 rounded-md bg-slate-100 text-slate-600 text-xs font-medium"
                    >
                      {highlight}
                    </span>
                  ))}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default UseCasesSection;
